import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';


@Injectable()
export class DatepickerAdapter extends NgbDateAdapter<string> {
  fromModel(value: string): NgbDateStruct | null {
    let result: NgbDateStruct | null = null;
    const date = new Date(Number.parseInt(value));
    if (value) {
      result = {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear(),
      };
    }
    return result;
  }

  toModel(date: NgbDateStruct): string | null {
    let result: string | null = null;
    if (date) {
      result = new Date(`${date.year}/${date.month}/${date.day}`).getTime().toString();
    }
    return result;
  }
}
